import { collection, getDocs } from "firebase/firestore";
import { auth, db } from "../firebase";

export default async function getSubscriptionStatus() {
  const uid = auth.currentUser.uid;

  const subRef = collection(db, "users", uid, "subscriptions");
  const snap = await getDocs(subRef);

  if (snap.empty) return { active: false, level: null };

  // Stripe can store multiple subscriptions, so we check them all
  let activeLevel = null;

  snap.forEach((doc) => {
    const data = doc.data();

    if (data.status === "active" || data.status === "trialing") {
       let priceID = data.price?.id || null;
       if(priceID == "price_1SVI0DHuyGumH9NacSrnz6Fr"){
            activeLevel = "pro";
       } else if (priceID == "price_1SVI1iHuyGumH9NagidrkDoP"){
            activeLevel = "basic";
       }
    }
  });
  
  return {
    active: activeLevel !== null,
    level: activeLevel,  // price ID of their plan
  };
}